// Small URL helpers used to derive a compact website slug for routing.

/**
 * Normalize any website string (with/without protocol/path) to a hostname.
 */
export function toHostname(input: string): string {
  try {
    const href = /^(https?:)?\/\//i.test(input) ? input : `https://${input}`;
    return new URL(href).hostname;
  } catch {
    // Fallback: strip protocol-like prefix and take up to first slash
    return String(input)
      .replace(/^(https?:)?\/\//i, "")
      .split("/")[0]
      .split(":")[0];
  }
}

/**
 * Compute a short, human-friendly slug from a website string for use in URLs.
 * Example: "www.apple.it" -> "apple"
 */
export function coreDomainSlug(input: string): string {
  let host = toHostname(input).toLowerCase();
  if (host.startsWith("www.")) host = host.slice(4);

  // If ends with .it, strip it first (explicit request), else keep generic behavior
  if (host.endsWith(".it")) host = host.slice(0, -3);

  // Return the first label before any remaining dots (e.g., apple from apple.com)
  const first = host.split(".")[0];
  return first || host;
}
